/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getW9SnapshotPiiData} from '../api'

 export const useQueryGetW9SnapshotPiiData = createReactQueryHook('getW9SnapshotPiiData', getW9SnapshotPiiData)
